<template>
    <outboxCon :bg="bg">
        <div class="technology">
            <app-title main='用科技驱动教育进步' sub='我们重新定义科教 科教重新定义未来'></app-title>
            <div class="technology-box">
                <div class="left-box">
                    <p class="left-info" :class="`left-${index+1}`" v-for="(item, index) in leftList" :key="`left${index}`">{{item}}</p>
                </div>
                <div class="tech-info">
                    <div class="tech-info-item" :class="`mgl-${index+1}`" v-for="(item, index) in techList" :key="`tech${index}`">
                        <p class="main">{{item.main}}</p>
                        <p class="sub">{{item.sub}}</p>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
import methosScroll from './hashScroll/methodScroll'
export default {
  props: {
    bg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      techList: [
        {
          main: 'AI课堂方案、AI课堂守护系统、功课批改',
          sub: '优选外教授课，结合AI技术实现每个孩子的专属教学方案；课后辅导自动批改，释放机构老师课后精力'
        },
        {
          main: '语音技术、图像技术、NLP、视频理解',
          sub: '通过人脸识别、动作识别以及答题器的数据反馈，把控授课难度与进度，实现因材施教'
        },
        {
          main: '教学语音、手写试题、教学视频、作业题库',
          sub: '通过打通学生课中和课后数据，全方面监测学生学习情况，让机构老师全面掌握学生学习情况'
        },
        {
          main: '线下课题AI硬件、云端XPU架构',
          sub: '自有硬件和云架构让上课流程更加流畅和稳定'
        }
      ],
      leftList: ['解决方案', '算法层', '数据层', '硬件层']
    }
  },
  components: { methosScroll }
}
</script>
<style lang="scss" scoped>
    .technology{
        width: $main-width;
        margin: 0 auto;
        padding: 50px 0px 60px 70px;
        position: relative;
        .technology-box{
            display: flex;
            justify-content: flex-start;
            align-content: center;
            margin-top: 67px;
            .left-box{
                width: 565px;
                height: 536px;
                background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/ai-3-1.png');
                background-size: 100% 100%;
                .left-info{
                    font-size:22px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    line-height:30px;
                    &.left-1{
                        margin-top: 99px;
                    }
                    &.left-2{
                        margin-top: 99px;
                    }
                    &.left-3{
                        margin-top: 85px;
                    }
                    &.left-4{
                        margin-top: 90px;
                    }
                }
            }
            .icon-tech{
                width: 565px;
                height: 536px;
            }
            .tech-info{
                .tech-info-item{
                    width:463px;
                    height:117px;
                    background:rgba(255,255,255,1);
                    border-radius:14px;
                    padding: 20px;
                    margin-top: 22px;
                    text-align: left;
                    position: relative;
                    .main{
                        height:28px;
                        font-size:20px;
                        font-family:PingFangSC-Semibold,PingFang SC;
                        font-weight:600;
                        line-height:28px;
                    }
                    .sub{
                        font-size:16px;
                        margin-top: 7px;
                        font-family:PingFangSC-Light,PingFang SC;
                        font-weight:300;
                        line-height:22px;
                    }
                    &:last-of-type{
                        padding-top: 29px;
                    }
                    &::before{
                        content: ' ';
                        height: 0px;
                        width: 120px;
                        border: none;
                        border-top: 2px dashed #9BA2A9;
                        display: inline-block;
                        position: absolute;
                        top: 59px;
                        left: -140px;
                    }
                    &.mgl-1{
                        margin-left: -50px;
                    }
                    &.mgl-2{
                        margin-left: 20px;
                    }
                    &.mgl-3{
                        margin-left: 90px;
                    }
                    &.mgl-4{
                        margin-left: 160px;
                    }
                }
            }
        }
    }
</style>
